import type { LanguageModel } from "@commercekit/api";
import type { ImageField, LinkField } from "@commercekit/prismic";
import classNames from "classnames";
import type { FC } from "react";
import type {
  LayoutDocumentDataLanguagesItem,
  LayoutDocumentDataNavLinksItem,
} from "~/lib/prismic";
import { useGlobalCtx } from "~/store/globalState";
import Header from "./__internal";
import WvHeaderUSPBar from "./__internal/WvHeaderUspBar";
import type { MenuCategory } from "~/types/MenuCategory";

const AppHeader: FC<{
  title: string;
  logo: ImageField;
  logoLink: LinkField;
  category: MenuCategory[];
  onBehalf: string;
  languageNames: LayoutDocumentDataLanguagesItem[];
  languages: LanguageModel[];
  locale: string;
  headerUspBar: LayoutDocumentDataNavLinksItem[];
  sooqrAccount: string;
  headerRating?: { rating: number; reviewCount: number } | null;
}> = (props) => {
  const { isCheckoutHeaderLayout } = useGlobalCtx();
  return (
    <>
      <header
        className={classNames("w-full py-3 wvheader py-lg-0", {
          "general-header": !isCheckoutHeaderLayout,
        })}
      >
        <Header.ShoppingCart {...props} />
        <Header.General {...props} />
      </header>
      {!isCheckoutHeaderLayout ? (
        <WvHeaderUSPBar headerUspBar={props.headerUspBar} />
      ) : null}
    </>
  );
};

export default AppHeader;
